import { FamousItem } from "./interface"
export const data: Array<FamousItem> = [{
  img: require('@/assets/images/famous/wxx.jpg'),
  name: "王贤星",
  title: [
    '（原）北京协和医院病案主任、门诊部主任、图书馆馆长',
    '1919年到协和医院，在宗教部募用处（相当现在的人事处）工作。',
    '1921年7月医院开院王贤星与伯沙·布林克利共同被任命，1923年伯沙离院，',
    '王贤星一直在病案科工作，直到1977年退休，先后曾同时兼任门诊部主任、图书馆馆长。',
    '1989年7月4日逝世，遗体捐赠给中国医学科学院中国协和医科大学。',
    '王老任职病案室期间，解决了协和前身北京施医院病案散放无专门管理的状况，',
    '整理了遗留的病案，统一编号，建立姓名索引，至今仍保存。建立了病案室，',
    '并制定了一系列的管理方法，首创我国病案的系统管理，优于国外。',
    '1984年马家润在美国旧金山等地考察7家医院病案管理，仍有医院沿用中国病案管理模式。'
  ],
  honor: ''
}, {
  img: require('@/assets/images/famous/mjr.jpg'),
  name: "马家润",
  title: [
    '（原）北京协和医院病案科副主任',
    '（原）北京医学会理事及病案管理委员会主任委员',
    '（原）病案管理专业委员会副主任委员',
    '（原）中华医院管理学会理事',
    '（原）《中国病案》杂志社副总编',
  ],
  honor: [
    '2002年被中华医院管理学会病案管理专业委员会授予“中国病案管理事业终身贡献奖”',
    '2009年获得中国医院协会论文编辑优秀奖。'
  ]

}, {
  img: require(`@/assets/images/famous/fpd.jpg`),
  name: "符品端",
  title: [
    "原解放军总医院病案科主任，副主任医师",
    "（原）全国病案信息管理学会常委和副主任委员三届",
    "北京病案管理学会副主任委员两届、主任委员两届",
  ],
  honor: "2004年8月20日获中华医院管理学会病案管理专业委员会颁发的“中国病案管理事业突出贡献奖”。"
}, {
  img: require('@/assets/images/famous/zzr.jpg'),
  name: '周卓然',
  title: '（原）上海市第一人民病史室副主任，农工民主党员，高级统计师，毕业于南京计政学院统计系，大专文化。',
  honor: '1950年10月-1952年12月在上海公济医院担任病史管理员，1953年1月-1986年10月担任上海市第一民医院病史室副主任，多次在全国、全市病史统计学习班中讲授病史统计课，曾担任病史管理学会组长，其参与编辑的《疾病和手术名称分类》作为全国第一部专著，曾译编英文专业工具书计170万字。 1981年-1982年连续两年被评为市卫生局先进工作者，1982年度市统计局先进工作者，1984年度院 先进工作者、农工党卫生局总支委员会先进工作者，1988年国家统计局颁发的专业荣誉证书，2002 年荣获中国病案管理事业终身贡献奖。'
}, {
  img: require("@/assets/images/famous/wqx.jpg"),
  name: "魏绮星",
  title: "（原）上海瑞金医院第一任“病史统计室”主任",
  honor: '1990年退休。从事病案工作近38年。曾担任上海市病史管理学组组长，为上海市病案管理专业做出 突出贡献。'
}, {
  img: require(`@/assets/images/famous/msz.jpg`),
  name: "马思志",
  title: [
    "副主任技师",
    "（原）解放军总医院病案科副主任",
    "（原）全军卫生档案专业委员会、中华病案学会副组长",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/zjh2.jpg`),
  name: "周锦华",
  title: "1971年--1989年在北京天坛医院工作，曾在心电图室、内科、耳鼻喉科、急诊室等临床科室工作。",
  honor: [
    "自1988年开始从事ICD的教学及专业师资的培训工作。",
    "1989作为我国第一个病案管理专业教学的专职教师，开始担任病案管理专业的所有教学工作。",
    "期间参与了国际病案协会教育委员会编著的《国际病案管理》；《中国病案管理论文精选》；",
    "《国际疾病分类ICD-10应用指导手册》；《新编病案管理学》；《全国病案信息专业资格考试》等",
    "多部专业教材的编辑。",
    "2003年--2018年作为北京大学医学网络教育学院的外聘教师，为该校讲学及系统地编写了《教学大纲》、",
    "《考试大纲》、《学习指导》、考试专用的《ICD简明查询手册》、及《试题库》等资料。"
  ]
}, {
  img: require(`@/assets/images/famous/yry.jpg`),
  name: "尤瑞玉",
  title: [
    "原北京电力医院病案统计科科长，从事病案管理、统计、疾病分类三十多年，",
    "参与制定国家标准《疾病分类与代码》"
  ],
  honor: [
    "现返聘负责医院的信息系统开发和管理",
    "中国医院协会病案专业委员会聘为疾病学组顾问",
    "中国医院协会病案专业委员培训师资"
  ]
}, {
  img: require('@/assets/images/famous/wxl.jpg'),
  name: "吴秀兰",
  title: [
    "（原）中国医院协会病案专业委员会委员",
    "（原）病案质控分会委员",
    "（原）北京医学会病案管理专业委员会委员",
    "（原）,《中国病案》杂志编辑委员会委员和责任编辑"
  ],
  honor: [
    "首都医科大学儿科系毕业后到北京儿童医院工作。",
    "1993年医院申报三级甲等医院时到病案室做病案质控。之后，逐渐加入病案管理专业学习、工作。",
  ]
}, {
  img: require('@/assets/images/famous/zjh.jpg'),
  name: "周佩华",
  title: '副教授，毕业于四川大学，是新中国第一批病案人。',
  honor: '在原四川医学院主持病案科工作40余年。主编《四川医学院附属医院医疗统计资料汇编（1949-1978）》，是四川乃至国内第一批国际疾病分类的传播者。'
}, {
  img: require('@/assets/images/famous/lam.jpg'),
  name: "刘爱民",
  title: [
    "（原）北京协和医院病案科主任",
    "国际病案协会理事",
    "中国医院协会病案管理专业委员会主任委员",
    "中国医疗保险研究会理事",
    "中国社区协会理事",
    "《中国病案》杂志社原总编",
    "卫生部病案管理专业晋升考试委员会主任委员",
    "北京医院协会理事",
  ],
  honor: '30余年来，作为主编或编委出版病案信息管理、疾病分类、手术分类等专业书籍或译著20余部。 发表论文30余篇，参与科研项目11项。'
}, {
  img: require('@/assets/images/famous/hys.jpg'),
  name: "胡燕生",
  title: [
    "（原）首都医科大学附属北京朝阳医院医务处长、门诊部副主任兼病案统计科主任",
    "中国医院协会病案专业委员会主任委员",
    "中国医院协会常务理事",
    "《中国病案》杂志社社长",
    "（原）首都医科大学附属北京朝阳医院河北燕达院区医疗院长",
    "（原）北京市卫生局病案质量控制与改进中心主任",

  ],
  honor: [
    "参加《中国病案》杂志创办，发表专业论文30余篇，参与专著编写6部，获卫生部科技进步三等奖1次。",
    "参加了国家卫生部“住院病案首页”修订与医疗机构病案管理专业技术高级职称申报工作。",
    "2004年被国家卫生部批准为“卫生技术人员职称晋升成熟系列”开始评定病案专业高级职称的工作，",
    "使病案专业技术职称评审主任技师、副主任技师得以实现。",
  ]
}, {
  img: require('@/assets/images/famous/mj.jpg'),
  name: "马娟",
  title: [
    "四川省人民医院病案科主任",
    "第五届中国医院协会病案专业委员会副主任委员"
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/lkx.jpg'),
  name: "刘克新",
  title: [
    "解放军总医院病案管理科主任  副主任医师",
    "中国医院协会病案专业委员会  副主任委员",
    "中国人民解放军卫生信息学专业  委员  病案学组组长",
    "北京医学会病案专业委员会  副主任委员",
    "《中国病案》杂志社  副总编辑",
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/myb.jpg'),
  name: "马云波",
  title: [
    "首都医科大学附属北京安贞医院病案统计科主任",
    "中国医院协会病案专业委员会副主任委员兼秘书长",
    "国家卫生计生委病案质量控制中心专家",
    "国家卫生计生委住院病案首页督导检查专家",
    "北京市卫计委病案质量控制和改进中心委员",
    "北京市朝阳区病案质量控制机改进中心副主任委员",
    "北京市卫计委DRGs论证委员会委员",
    "《中国病案》杂志社副主编辑",
    "北京市卫计委医院评审专家",
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/lwh.jpg'),
  name: "李卫红",
  title: [
    "首都医科大学附属北京同仁医院医院办公室主任兼病案科主任  主任技师",
    "中国医院协会病案专业委员会  副主任委员",
    "国家卫生与计划生育委员会病案质控中心  专家",
    "北京医学会病案专业委员会  副主任委员  候任主任委员",
    "北京市病案质量控制与改进中心  专家委员",
    "北京市医疗管理数据质量控制和改进中心  专家委员",
    "北京市DRGs论证专家委员会  委员 ",
    "《中国病案》杂志社  副总编辑",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/hdm.jpg`),
  name: "候东敏",
  title: [
    "首都医科大学附属北京妇产医院医务处处长",
    "超声医学  主任医师",
    "影像医学与核医学硕士",
    "社会医学与卫生事业管理学硕士",
    "中国医院协会病案专业委员会副主任委员",
    "病案质量监控学组组长",
    "中国妇幼保健协会医疗风险防控专业委员会委员",
    "北京医学会病案管理专业委员会常委",
    "北京医学会医院管理评价委员会委员",
    "北京医学会医政、技术准入专家委员",
    "北京市病案质量控制和改进中心专家委员会委员",
    "北京市医疗机构互联网诊疗准入评审专家",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/sgw.jpg`),
  name: "索冠伟",
  title: [
    "天津医科大学第二医院病案统计科主任，副主任医师、副教授",
    "中国医院协会病案专业委员会副主任委员",
    "质量监控学组委员",
    "天津市医院协会病案专业委员会主任委员",
    "天津市病案质控中心副主任",
    "天津市疾病和手术操作分类编码专家组副组长",
    "《中国病案》杂志社第五届编辑委员会委员",
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/jgz.jpg'),
  name: "季国忠",
  title: [
    "南京医科大学第二附属医院党委书记  主任医师",
    "南京医科大学第二临床医学院党委书记",
    "中国医院协会病案专业委员会  副主任委员",
    "国家教育部高等学校临床医学专业教学指导委员会  委员",
    "中国医师协会内镜质量控制委员会  副主任委员",
    "江苏省医院协会病案专业委员会  主任委员",
    "江苏省医学会及医院协会  常务理事",
    "江苏省及南京市医学会消化分会  副主任委员",
  ],
  honor: ''
}, {
  img: require('@/assets/images/famous/cyq.jpg'),
  name: "常艳群",
  title: [
    "山东省立医院质控绩效办副主任  主任医师",
    "中国医院协会病案专业委员会  副主任委员 病案质控专业组副组长",
    "山东省医院协会病案专业委员会  主任委员",
    "《中国病案》杂志社  编委",
    "山东省医院等级评审专家",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/zsy.jpg`),
  name: "赵淑媛",
  title: [
    "医学学士，主任技师，现任广东省人民医院病案科主任",
    "中国医院协会病案专业委员会副主任委员",
    "广东省医院协会病案管理专业委员会主任委员",
    "广东现代医院研究所研究员",
    "中山大学兼职教授",
    "广东省卫生系列高级专业技术资格评审委员会评审专家"
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/fmn.jpg'),
  name: '樊美娜',
  title: [
    "中国医学科学院肿瘤医院深圳医院医务部副主任兼物价医保办主任、门诊部主任  主任技师",
    "中国医院协会病案专业委员会  副秘书长  常务委员  随访工作专业组组长",
    "中国医院协会医疗质量专业委员会病案质控学组  委员 ",
    "国家病案质控中心  委员",
    "北京市卫生和计划生育委员会DRG项目组数据管理和质量控制组  副组长",
    "北京肿瘤学会病案信息技术专业委员会  副主任委员  候任主任委员  秘书长",
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/zhw.jpg'),
  name: "张红卫",
  title: [
    "首都医科大学附属北京潞河医院病案统计科主任  副主任技师",
    "中国医院协会病案专业委员会  副秘书长",
    "北京病案质量控制与改进中心  专家委员",
    "北京医学会病案专业委员会  委员",
    "北京肿瘤学会病案信息技术专业委员会  委员",
    "《中国病案》杂志社  责任编辑",
  ],
  honor: ''
}, {
  img: require('@/assets/images/famous/llh.jpg'),
  name: '李丽华',
  title: [
    "首都医科大学附属北京朝阳医院病案科主任",
    "中国医院协会病案专业委员会  副秘书长",
    "北京病案质量控制与改进中心  专家委员",
    "北京肿瘤学会病案信息技术专业委员会  委员",
    "《中国病案》杂志社  责任编辑",
  ],
  honor: ''
}, {
  img: require('@/assets/images/famous/wn.jpg'),
  name: "王宁",
  title: [
    "江苏卫生健康职业学院信息中心主任 副教授",
    "中国医院协会病案专业委员会  常务委员  教育学专业组组长",
    "江苏省医院评审委员会  常委 ",
    "教育部卫生行业专业指导委员会公共卫生与卫生管理专业委员会  委员 ",
    "南京卫生信息学会信息统计专业委员会 副主任委员",
  ],
  honor: ''
}, {
  img: require('@/assets/images/famous/xxw.jpg'),
  name: '徐锡武',
  title: [
    "北京医院门诊部  副主任",
    "中国医院协会病案专业委员会  常务委员  电子病案学专业组组长",
    "中国医院协会医疗质量专业委员会  委员  病案学组秘书",
    "北京市病案质量控制与改进中心  专家委员",
    "北京肿瘤学会病案信息技术专业委员会  副主任委员",
    "《中国病案》杂志社  编委",
  ],
  honor: ''
}, {
  img: require('@/assets/images/famous/wlm.jpg'),
  name: "吴良明",
  title: [
    "南京鼓楼医院信息处处长  高级统计师",
    "中国医院协会病案专业委员会  常务委员  疾病分类专业组组长",
    "江苏建康学院卫生信息专业教学指导委员会  主任委员",
    "《中国病案》杂志社  编委",
  ],
  honor: ''
}, {
  img: require("@/assets/images/famous/yjn.jpg"),
  name: "杨建男",
  title: [
    "（原）成都大学附属医院病案科主任、质控部主任。",
    "《中国病案》杂志编委",
    "四川省卫健委医院等级评审资深专家",
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/zl.jpg'),
  name: "赵莉",
  title: [
    "主任技师，现任海南省肿瘤医院医务部副主任，病案室主任",
    "中国医院协会病案专业委员会常委",
    "中国病案杂志编委会委员",
    "中国统计学会委员",
    "黑龙江省医学会病案专业委员会主任委员",
    "海南省非公协会病案专业委员会副主任委员",
  ],
  honor: ""
}, {
  img: require('@/assets/images/famous/mcm.jpg'),
  name: "莫春梅",
  title: [
    "四川大学华西医院病案科科长，副主任技师，流行病学与卫生统计专业硕士",
    "中国医院协会病案专业委员会常委",
    "四川省医疗管理工作组专家",
    "四川省病案质控中心副主任",
    "四川省医院协会病案管理分会副会长",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/lhz.jpg`),
  name: '林洁中',
  title: [
    "广东湛江中心人民医院原信息科副科长、医疗技术顾问、病案管理副主任技师。",
    "（原）全国ICD—9协作组成员",
    "全国卫生信息（病案）教育委员会委员",
    "广东省医院管理协会病案管理专业委员会副主任",
    "湛江市医院管理学会常务理事",
    "湛江市医院分级管理评委",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/qyb.jpg`),
  name: "裘以冰",
  title: [
    "临床医学学士，病案管理主任技师，广东省人民医院原病案科主任，2007年退休",
    "（原）中国医院协会病案专业委员会常委及病案质量监控委员会副主任委员",
    "广东省医院协会病案专业委员会主任委员",
    "广东省医院管理学会理事",
    "广东现代医院管理研究所研究员",
    "广东省卫生医疗机构高级技术职称评审委员会评审专家",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/shp.jpg`),
  name: "帅海平",
  title: [
    "副主任医师。现任上海市第六人民医院病案统计室主任",
    "中国医院协会病案专业委员会常务委员",
    "中国医院协会医疗质量管理专业委员会病案质控学组委员",
    "国家信息中心疾病分类代码专家组成员",
    "《中国病案》编委",
    "上海医院协会病案管理专业委员会副主任委员",
    "上海病历质量控制中心专家委员",
    "上海市医保支付方式改革咨询专家",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/wqs.jpg`),
  name: "王岐山",
  title: [
    "陕西省人民医院原业务副院长，血液内科一级主任医师，二级教授，延安大学医学院硕士研究生导师，",
    "西北工业大学临床研究院特聘研究员，陕西省卫健委“215”人才，获全国“5.1”劳动奖章。",
  ],
  honor: [
    '陕西省病案质量控制管理中心主任',
    '陕西省医学会血液学分会副主任委员',
    '中国医院协会病案专业委员会常委',
    '陕西省抗癌协会监事',
    '陕西妇女健康促进会会长',
    '陕西省健康细胞示范建设省级指导专家',
  ]
}, {
  img: require(`@/assets/images/famous/cy.jpg`),
  name: "蔡艳",
  title: [
    "本科学历，高级统计师，原系新疆建设兵团总医院信息科主任。1983年从事病案统计工作2017年退休。"
  ],
  honor: [
    "（原）中国医院协会病案专业委员会常务委员",
    "新疆医院病案管理学会秘书长",
    "兵团医学杂志主编",
  ]
}, {
  img: require(`@/assets/images/famous/czc.jpg`),
  name: "陈珍初",
  title: [
    "皖南医学院第一附属医院弋矶山医院病案科主任",
    "安徽省病案质量控制中心常务副主任",
    "安徽省医院协会病案管理专业委员会秘书长",
    "国家病案质量控制中心疾病编码专家组委员",
    "中国医院协会病案专业委员会委员及疾病分类学组委员",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/cy2.jpg`),
  name: "陈媛",
  title: [
    "云南省第一人民医院病案统计科科长，高级统计师",
    "中国医院协会病案专委会常务委员",
    "《中国病案》杂志编委",
    "云南省病案质量控制中心主任",
    "云南省医院协会病案专委会主任委员",
    "中国医院协会医疗质量专委会病案质控学组委员",
    "云南省医院协会DRGs专委会委员",
    "国家医保局DRG付费试点专家组成员",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/fh.jpg`),
  name: "方浩",
  title: [
    "科主任，主任技师，现1987年7月至今，从事病案工作33年。",
    "中国医院协会病案专业委员会常务委员",
    "宁夏医院协会病案管理委员会主任委员",
    "第五届《中国病案》杂志社编辑委员会委员",
    "海峡两岸医药卫生交流协会海西医药卫生发展中心病案学专业委员会副主任委员",
    "宁夏病案质控中心副主任委员",
  ],
  honor: [
    "2016年主持宁夏自然科学基金一项，2019年主管自治区卫生健康系统项目一项，",
    "2020年主管宁夏自然科学基金一项，先后发表论文10余篇。",
  ]
}, {
  img: require(`@/assets/images/famous/hy.jpg`),
  name: "何艺",
  title: [
    "华中科技大学同济医学院附属同济医院病案科主任，从事病案管理工作17年，从事儿科临床工作15年。",
    "湖北省病历质控中心主任委员",
    "湖北卫生统计与信息学会病案统计专业委员会主任委员",
    "武汉市疾病诊断相关分组（DRG）付费试点专家组成员中的技术指导成员",
    "中国医院协会病案专业委员会常委",
    "国家质量控制中心专业委员会委员",
    "湖北省病案专业委员会委员",
  ],
  honor: "承担湖北省科技攻关计划课题和湖北湖北省自然科学基金课题两项，参与（第三）国家卫生计生委统计信息中心委托华中科技大学关于《中文医学术语标准开发前期研究》，以第一作者和通讯作者发表论文20篇，主编《全国卫生专业技术资格考试习题丛书-病案信息技术精选模拟习题集》由人民卫生出版社出版，主编和参编《医疗机构病历书写规范》由科学出版社，（2003年）和湖北人民出版社出版(2016年)出版。"
}, {
  img: require(`@/assets/images/famous/ccx.jpg`),
  name: "陈彩霞",
  title: [
    "深圳市人民医院病案管理科主任、病案管理科主任、病案信息主任技师，从事病案工作28年。",
    "中国医院协会病案管理专业委员会疾病分类学组副主任委员",
    "《中国病案》杂志社 编委",
    "广东省医院协会病案管理专业委员会 副主任委员 ",
    "深圳市医院协会病案分会 会长",
    "深圳市病案管理质量控质中心主任",
    "深圳市卫生信息协会病案管理信息化专业委员会 主任委员深圳C-DRG专家组成员",
  ],
  honor: ""
}, {
  img: require(`@/assets/images/famous/sj.jpg`),
  name: "沈洁",
  title: [
    "广东省粤北人民医院病案室主任",
    "中国医院协会病案管理专委会委员",
    "广东省病案管理专委会副主任委员",
    "韶关市病案管理专委会主任委员",
    "广东省卫健委DRGs专家组成员",
    "广东省卫健委病历质控中心专家组成员",
    "韶关市深化医药卫生体制改革专家组成员",
    "韶关市病种分值专家组成员",
  ],
  honor: "出版专著《ICD-9列表导索ICD-10》，荣获2016年广东省医院协会先进个人称号。",
}, {
  img: require(`@/assets/images/famous/ll.jpg`),
  name: "刘莉",
  title: [
    "同济医科大学医学专业学士，主任技师",
    "现任深圳大学第一附属医院（深圳市第二人民医院）病案统计图书科主任",
    "中国医院协会病案专业委员会委员",
    "中国信息学会医院统计专委会委员",
    "中国信息学会健康医疗大数据人力资源开发专委会常务委员",
    "广东省医院协会病案专委会副主任委员",
    "深圳医学会理事",
    "深圳市病案专委会副主任委员",
    "深圳市医疗数据质量控制中心主任",
  ],
  honor: "",
}, {
  img: require(`@/assets/images/famous/yl.jpg`),
  name: "杨莉",
  title: [
    "教授，主任医师，研究生导师，江苏省病案东南大学医学院儿科学系副主任",
    "东南大学附属中大医院医疗督导组常务副主任，教学督导专家",
    "医院伦理委员会副主任委员，东南大学附属中大医院溧水分院医疗总监",
    "历任东南大学附属中大医院儿科副主任、医务处主任、质控中心主任、门诊部主任",
    "中国医院协会病案管理专业委员会委员",
    "江苏省病案管理质控中心常务副主任",
    "江苏省医院协会病案管理专业委员会副主任委员",
    "江苏省医学会变态反应分会委员",
    "中华医学会江苏省分会儿科学呼吸学组委员",
    "江苏省药学会临床试验区域医院伦理委员会委员",
    "南京市病案质控中心副主任委员",
    "南京医学会变态反应分会委员"
  ],
  honor: "",
}]